/* eslint-disable import/prefer-default-export */
import { readonly } from 'vue';
import { useRoute } from 'vue-router';
import { useBrand } from '@composables/useBrand';

export const useBagContext = () => {
  const { query } = useRoute();
  const { isBcom } = useBrand();

  const isUpdateBagEnabled = isBcom && query?.EXTRA_PARAMETER === 'BAG';
  const sequenceNumber = (isUpdateBagEnabled && query?.seqNo) ? Number.parseInt(query?.seqNo, 10) : 0; // 0 - is fallback value

  return readonly({
    isUpdateBagEnabled,
    sequenceNumber,
  });
};
